import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const asyncRouterMap = [{
        path: '/middleware',
        name: 'middleware',
        meta: {
            title: ''
        },
        component: () =>
            import ('../views/login/middleware'),
    }, {
        path: '/protocol',
        name: 'protocol',
        meta: {
            title: '服务协议'
        },
        component: () =>
            import ('../views/login/protocol'),
    }, {
        path: '/phoneLogin',
        name: 'phoneLogin',
        meta: {
            title: '登录'
        },
        component: () =>
            import ('../views/login/phoneLogin'),
    },
    {
        path: '/codeLogin',
        name: 'codeLogin',
        meta: {
            title: '登录'
        },
        component: () =>
            import ('../views/login/codeLogin'),
    }, {
        path: '/',
        name: 'index',
        meta: {
            title: '阿拉丁网上照明展',
        },
        component: () =>
            import ('../views/index/index'),
    },
    {
        path: '/dailyNews',
        name: 'dailyNews',
        meta: {
            title: '新闻资讯',
        },
        component: () =>
            import ('../views/index/dailyNews'),
    },
    {
        path: '/industryGuru',
        name: 'industryGuru',
        meta: {
            title: '行业大咖',

        },
        component: () =>
            import ('../views/index/industryGuru'),
    },
    {
        path: '/guruSearch',
        name: 'guruSearch',
        meta: {
            title: '搜索页',
        },
        component: () =>
            import ('../views/index/guruSearch'),
    },

    {
        path: '/allSearch',
        name: 'allSearch',
        meta: {
            title: '阿拉丁网上照明展',
        },
        component: () =>
            import ('../views/index/allSearch'),
    },
    {
        path: '/trendDetails',
        name: 'trendDetails',
        meta: {
            title: '动态详情'
        },
        component: () =>
            import ('../views/index/trendDetails'),
    },
    {
        path: '/videoDetails',
        name: 'videoDetails',
        meta: {
            title: '视频动态'
        },
        component: () =>
            import ('../views/index/videoDetails'),
    },
    {
        path: '/articleDetail',
        name: 'articleDetail',
        meta: {
            title: '文章'
        },
        component: () =>
            import ('../views/index/articleDetail'),
    },
    {
        path: '/videoDetail',
        name: 'videoDetail',
        meta: {
            title: '视频'
        },
        component: () =>
            import ('../views/index/videoDetail'),
    },
    {
        path: '/myPostcard',
        name: 'myPostcard',
        meta: {
            title: '我的名片'
        },
        component: () =>
            import ('../views/postcardCenter/myPostcard'),
    },
    {
        path: '/modifyPostcard',
        name: 'modifyPostcard',
        meta: {
            title: '修改名片'
        },
        component: () =>
            import ('../views/postcardCenter/modifyPostcard'),
    },
    {
        path: '/postcardDetail',
        name: 'postcardDetail',
        meta: {
            title: '名片详情'
        },
        component: () =>
            import ('../views/postcardCenter/postcardDetail'),
    },
    {
        path: '/receivePostcard',
        name: 'receivePostcard',
        component: () =>
            import ('../views/postcardCenter/receivePostcard'),
    },
    {
        path: '/addPostcard',
        name: 'addPostcard',
        meta: {
            title: '创建名片'
        },
        component: () =>
            import ('../views/postcardCenter/addPostcard'),
    },
    {
        path: '/exhibition',
        name: 'exhibition',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/exhibition'),
    },
    {
        path: '/expoCar',
        name: 'expoCar',
        meta: {
            title: '申领车证'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoCar'),
    },
    {
        path: '/drivingLicense',
        name: 'drivingLicense',
        meta: {
            title: '信息填写'
        },
        component: () =>
            import ('../views/exhibitionCenter/drivingLicense'),
    },
    {
        path: '/viewOrder',
        name: 'viewOrder',
        meta: {
            title: '查看预约'
        },
        component: () =>
            import ('../views/exhibitionCenter/viewOrder'),
    },

    {
        path: '/exhibitionIntroduce',
        name: 'exhibitionIntroduce',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/exhibitionIntroduce'),
    },

    {
        path: '/expoLatestBooth',
        name: 'expoLatestBooth',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoLatestBooth'),
    },
    {
        path: '/expoActivity',
        name: 'expoActivity',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoActivity'),
    },
    {
        path: '/attendinfo',
        name: 'attendinfo',
        meta: {
            title: '观众预登记'
        },
        component: () =>
            import ('../views/exhibitionCenter/attendinfo'),
    },
    {
        path: '/attendinfocopy',
        name: 'attendinfocopy',
        meta: {
            title: '观众预登记(副本)'
        },
        component: () =>
            import ('../views/exhibitionCenter/attendinfocopy'),
    },
    {
        path: '/ticket',
        name: 'ticket',
        meta: {
            title: '查看门票'
        },
        component: () =>
            import ('../views/exhibitionCenter/ticket'),
    },
    
    {
        path: '/expoExhibitor',
        name: 'expoExhibitor',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoExhibitor'),
    },
    {
        path: '/expoExhibitorDetail',
        name: 'expoExhibitorDetail',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoExhibitorDetail'),
    },

    {
        path: '/expoBuilder',
        name: 'expoBuilder',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoBuilder'),
    },

    {
        path: '/expoHotel',
        name: 'expoHotel',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoHotel'),
    },

    {
        path: '/expoVisitGuide',
        name: 'expoVisitGuide',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoVisitGuide'),
    },
    {
        path: '/expoJoinGuide',
        name: 'expoJoinGuide',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/expoJoinGuide'),
    },
    {
        path: '/pdfBox',
        name: 'pdfBox',
        meta: {
            title: '2026广州国际照明展览会(光亚展)'
        },
        component: () =>
            import ('../views/exhibitionCenter/pdfBox'),
    },
    {
        path: '/message',
        name: 'message',
        meta: {
            title: '消息'
        },
        component: () =>
            import ('../views/messageCenter/message'),
    },
    {
        path: '/sysMessage',
        name: 'sysMessage',
        meta: {
            title: '系统消息'
        },
        component: () =>
            import ('../views/messageCenter/sysMessage'),
    },
    {
        path: '/chat',
        name: 'chat',
        meta: {
            title: "聊一聊"
        },
        component: () =>
            import ('../views/messageCenter/chat'),
    },
    {
        path: '/member',
        name: 'member',
        meta: {
            title: '我的'
        },
        component: () =>
            import ('../views/memberCenter/member'),
    },
    {
        path: '/homePage',
        name: 'homePage',
        meta: {
            title: '我的主页'
        },
        component: () =>
            import ('../views/memberCenter/homePage'),
    },
    {
        path: '/searchHomepage',
        name: 'searchHomepage',
        meta: {
            title: '搜索个人动态',
        },
        component: () =>
            import ('../views/memberCenter/searchHomepage'),
    },


    {
        path: '/userSetting',
        name: 'userSetting',
        meta: {
            title: '账户设置'
        },
        component: () =>
            import ('../views/memberCenter/userSetting'),
    },
    {
        path: '/myFile',
        name: 'myFile',
        meta: {
            title: '我的资料'
        },
        component: () =>
            import ('../views/memberCenter/myFile'),
    },


    {
        path: '/myLike',
        name: 'myLike',
        meta: {
            title: '我的点赞'
        },
        component: () =>
            import ('../views/memberCenter/myLike'),
    },
    {
        path: '/myAttention',
        name: 'myAttention',
        meta: {
            title: '我的关注'
        },
        component: () =>
            import ('../views/memberCenter/myAttention'),
    },
    {
        path: '/giveLike',
        name: 'giveLike',
        meta: {
            title: '我的点赞'
        },
        component: () =>
            import ('../views/memberCenter/giveLike'),
    },
    {
        path: '/collection',
        name: 'collection',
        meta: {
            title: '我的收藏'
        },
        component: () =>
            import ('../views/memberCenter/collection'),
    },
    {
        path: '/comment',
        name: 'comment',
        meta: {
            title: '我的评论'
        },
        component: () =>
            import ('../views/memberCenter/comment'),
    },
    {
        path: '/history',
        name: 'history',
        meta: {
            title: '浏览历史'
        },
        component: () =>
            import ('../views/memberCenter/history'),
    },

    {
        path: '/topicsDiscover',
        name: 'topicsDiscover',
        meta: {
            title: '发现'
        },
        component: () =>
            import ('../views/topicCenter/topicsDiscover'),
    },
    {
        path: '/nextTopic',
        name: 'nextTopic',
        meta: {
            title: '话题'
        },
        component: () =>
            import ('../views/topicCenter/nextTopic'),
    },
    {
        path: '/hotTopicDetails',
        name: 'hotTopicDetails',
        meta: {
            title: '话题详情',
        },
        component: () =>
            import ('../views/topicCenter/hotTopicDetails'),
    },
    {
        path: '/hotBlock',
        name: 'hotBlock',
        meta: {
            title: '热点中心',

        },
        component: () =>
            import ('../views/topicCenter/hotBlock'),
    },
    {
        path: '/myTopic',
        name: 'myTopic',
        meta: {
            title: '我的话题'
        },
        component: () =>
            import ('../views/topicCenter/myTopic'),
    },
    {
        path: '/publishVideo',
        name: 'publishVideo',
        meta: {
            title: '发布视频'
        },
        component: () =>
            import ('../views/publishCenter/publishVideo'),
    },
    {
        path: '/publishPic',
        name: 'publishPic',
        meta: {
            title: '发布动态'
        },
        component: () =>
            import ('../views/publishCenter/publishPic'),
    },
    {
        path: '/publishTopic',
        name: 'publishTopic',
        meta: {
            title: '创建话题'
        },
        component: () =>
            import ('../views/publishCenter/publishTopic'),
    },
    {
        path: '/specificActDetail',
        name: 'specificActDetail',
        component: () =>
            import ('../views/liveCenter/specificActDetail'),
    },
    {
        path: '/lbList',
        name: 'lbList',
        component: () =>
            import ('../views/liveCenter/lbList'),
    },
    {
        path: '/lbRanking',
        name: 'lbRanking',
        meta: {
            title: '直播排行榜'
        },
        component: () =>
            import ('../views/liveCenter/lbRanking'),
    },

    {
        path: '/actIntro',
        name: 'actIntro',
        meta: {
            title: '活动介绍'
        },
        component: () =>
            import ('../views/liveCenter/actIntro'),
    },
    {
        path: '/onlineExhibition',
        name: 'onlineExhibition',
        meta: {
            title: '直播中心',

        },
        component: () =>
            import ('../views/liveCenter/onlineExhibition'),
    },
    {
        path: '/activity',
        name: 'activity',
        component: () =>
            import ('../views/liveCenter/activity'),
    },
    {
        path: '/liveSearch',
        name: 'liveSearch',
        meta: {
            title: '搜索'
        },
        component: () =>
            import ('../views/liveCenter/liveSearch'),
    },
    {
        path: '/liveOnline',
        name: 'liveOnline',
        meta: {
            title: '正在直播'
        },
        component: () =>
            import ('../views/liveCenter/liveOnline'),
    },
    {
        path: '/livePreview',
        name: 'livePreview',
        meta: {
            title: '直播预告'
        },
        component: () =>
            import ('../views/liveCenter/livePreview'),
    },
    {
        path: '/specificAct',
        name: 'specificAct',
        meta: {
            title: '专题活动'
        },
        component: () =>
            import ('../views/liveCenter/specificAct'),
    },
    {
        path: '/specialCalendar',
        name: 'specialCalendar',
        meta: {
            title: '活动日历'
        },
        component: () =>
            import ('../views/liveCenter/specialCalendar'),
    },
    {
        path: '/onlineExhibitionTopics',
        name: 'onlineExhibitionTopics',
        meta: {
            title: '2023阿拉丁网上照明展览会',

        },
        component: () =>
            import ('../views/liveCenter/onlineExhibitionTopics'),
    },
    {
        path: '/brandLive',
        name: 'brandLive',
        meta: {
            title: '品牌连线',

        },
        component: () =>
            import ('../views/liveCenter/brandLive'),
    },
    {
        path: '/newBrands',
        name: 'newBrands',
        meta: {
            title: '品牌新品推荐',

        },
        component: () =>
            import ('../views/liveCenter/newBrands'),
    },
    {
        path: '/storeShow/:mid',
        name: 'storeShow',
        component: () =>
            import ('../views/storeCenter/storeShow'),
    },
    {
        path: '/storeShow',
        name: 'storeShow1',
        component: () =>
            import ('../views/storeCenter/storeShow'),
    },
    {
        path: '/companyIntro',
        name: 'companyIntro',
        meta: {
            title: '公司介绍'
        },
        component: () =>
            import ('../views/storeCenter/companyIntro'),
    },
    {
        path: '/contact',
        name: 'contact',
        meta: {
            title: '联系'
        },
        component: () =>
            import ('../views/storeCenter/contact'),
    },
    {
        path: '/videoList',
        name: 'videoList',
        meta: {
            title: '视频列表'
        },
        component: () =>
            import ('../views/storeCenter/videoList'),
    },
    {
        path: '/articleList',
        name: 'articleList',
        meta: {
            title: '文章列表'
        },
        component: () =>
            import ('../views/storeCenter/articleList'),
    },
    {
        path: '/product',
        name: 'product',
        meta: {
            title: '产品列表'
        },
        component: () =>
            import ('../views/productCenter/product'),
    },
    {
        path: '/productDetail',
        name: 'productDetail',
        meta: {
            title: '产品详情'
        },
        component: () =>
            import ('../views/productCenter/productDetail'),
    },
    {
        path: '/lightingIndex',
        name: 'lightingIndex',
        meta: {
            title: '神灯奖',

        },
        component: () =>
            import ('../views/lighting/lightingIndex'),
    },
    {
        path: '/previous',
        name: 'previous',
        meta: {
            title: '',

        },
        component: () =>
            import ('../views/lighting/previous'),
    },
    {
        path: '/project',
        name: 'project',
        meta: {
            title: '',
        },
        component: () =>
            import ('../views/lighting/project'),
    },
    {
        path: '/promotion',
        name: 'promotion',
        meta: {
            title: '宣传推广',
        },
        component: () =>
            import ('../views/lighting/promotion'),
    },
    {
        path: '/newslist',
        name: 'newslist',
        meta: {
            title: '新闻动态',
        },
        component: () =>
            import ('../views/lighting/newslist'),
    },
    {
        path: '/about',
        name: 'about',
        meta: {
            title: '关于神灯奖',
        },
        component: () =>
            import ('../views/lighting/about'),
    },
    {
        path: '/setting',
        name: 'setting',
        meta: {
            title: '奖项设置',
        },
        component: () =>
            import ('../views/lighting/setting'),
    },

    {
        path: '/judges',
        name: 'judges',
        meta: {
            title: '推荐&评委',

        },
        component: () =>
            import ('../views/lighting/judges'),
    },

    {
        path: '/projectDetail',
        name: 'projectDetail',
        meta: {
            title: '作品详情',

        },
        component: () =>
            import ('../views/lighting/projectDetail'),
    },
    {
        path: '/recDetail',
        name: 'recDetail',
        meta: {
            title: '详情',

        },
        component: () =>
            import ('../views/lighting/recDetail'),
    },
]

export default new Router({
    mode: 'history', //后端支持可开
    // scrollBehavior: () => ({
    //     y: 0
    // }),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            if (from.meta.keepAlive) {
                from.meta.savedPosition = document.body.scrollTop
            }
            return {
                x: 0,
                y: to.meta.savedPosition || 0
            }
        }
    },
    routes: [...asyncRouterMap]
})